import { useState } from "react";
import { Lock } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function PasscodeGate({ onUnlock }) {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const r = await fetch(`${API}/api/marketing/stats/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ passcode: code }),
      });
      const data = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(data.detail || "Could not sign in");
      onUnlock(data.token);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#22384F] flex items-center justify-center px-5">
      <form
        onSubmit={submit}
        data-testid="launch-stats-gate"
        className="w-full max-w-sm bg-white rounded-2xl p-8 shadow-[0_30px_60px_-20px_rgba(0,0,0,0.5)]"
      >
        <div className="w-11 h-11 rounded-xl bg-[#334E68]/10 text-[#334E68] flex items-center justify-center mb-5">
          <Lock size={20} />
        </div>
        <h1 className="font-display font-extrabold text-[24px] text-[#1A2A3A] tracking-[-0.02em]">Launch statistics</h1>
        <p className="text-[14px] text-[#5B6B7B] mt-1 mb-6">Private. Enter your passcode to continue.</p>
        <input
          type="password"
          autoComplete="current-password"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          data-testid="launch-stats-passcode-input"
          aria-label="Passcode"
          placeholder="Passcode"
          className="w-full px-4 py-3 rounded-xl border border-[#D9DEE4] focus:outline-none focus:ring-2 focus:ring-[#334E68] text-[15px]"
        />
        {error && (
          <p className="text-[13px] text-[#B42318] mt-3" role="alert" data-testid="launch-stats-gate-error">{error}</p>
        )}
        <button
          type="submit"
          disabled={busy || !code}
          data-testid="launch-stats-unlock-button"
          className="w-full mt-5 py-3 rounded-full bg-[#E8712C] hover:bg-[#C55A1F] disabled:opacity-50 text-white font-semibold transition-colors"
        >
          {busy ? "Checking…" : "Unlock"}
        </button>
      </form>
    </div>
  );
}
